import { useTranslation } from "react-i18next";
import type { PriceData } from "~/models/PriceData";
import { isUniversalKITProduct, type ProductData } from "~/models/ProductData";
import { text2, volatileSum } from "~/utils/PriceUtils";

interface KitPricesProps {
  className?: string;
  totalPrice: PriceData;
  optionalPartsPrice: PriceData;
  product: ProductData;
  includesSurcharge?: boolean;
  optionalPartsIncludesSurcharge?: boolean;
}

export const KitPrices = ({
  className,
  totalPrice,
  optionalPartsPrice,
  product,
  includesSurcharge,
  optionalPartsIncludesSurcharge,
}: KitPricesProps) => {
  const { t } = useTranslation();
  const isUniversal = isUniversalKITProduct(product);
  const totalNetPrice = isUniversal ? volatileSum(totalPrice, optionalPartsPrice) : optionalPartsPrice;
  const totalIncludesSurcharge = (includesSurcharge || optionalPartsIncludesSurcharge) && totalNetPrice.value > 0;
  return (
    <div className={className}>
      <div className={"d-flex flex-direction-column mb-3"}>
        <span className={"headline-medium f-bold"}>
          {text2(totalNetPrice, t("product.priceOnRequest"))}
          {totalIncludesSurcharge && "*"}
        </span>
        <span className={"f-label-color label-large"}>{t("pricing.housing.total.final")}</span>
      </div>
      {isUniversal && (
        <div className={"d-flex flex-direction-column mb-2"}>
          <span className={"title-medium"}>{text2(totalPrice, t("product.priceOnRequest"))}</span>
          <span className={"f-label-color label-large"}>{t("pricing.housing.total.included")}</span>
        </div>
      )}
      <div className={"d-flex flex-direction-column"}>
        <span className={"title-medium"}>{text2(optionalPartsPrice, t("product.priceOnRequest"))}</span>
        <span className={"f-label-color label-large"}>{t("pricing.housing.total.optional")}</span>
      </div>
    </div>
  );
};
